import { Model } from './model';

export class FeatureModel implements Model{
  name: string;
  fId: number;
  id: string;
  scenario: string[];
  _type = "feature";
}
